module.exports = __webpack_public_path__ + "media/hailuo23-ai-video-demo2.154fbb2d.mp4";